import React from "react"
import { Platform } from "~/ui/primitives"
import { InputTextFloatLabel } from "~components/input-text"
import { rules } from "~utils/validator"

interface Props {
  value: string
  placeholder?: string
  onChange: (value: string) => void
}

const Username: React.FC<Props> = ({ value, onChange, ...rest }) => (
  <InputTextFloatLabel
    label="邮箱或手机号"
    keyboardType={ "default"}
    placeholder="请输入邮箱或手机号"
    autoComplete="username"
    textContentType="username"
    value={value}
    onChangeText={onChange}
    validRule={rules.account}
    {...rest}
  />
)

export default Username
